/**
 * In line with the rest of this project
 * everything is designed mobile-first, so
 * components are likely to simply stack
 * on the vertical axis, before splitting
 * to wider arrangements.
 */

export const main = "m1xlzvrd";
export const gap_xxl = "gvwlgxl";
export const gap_xl = "g1wl3ji9";
export const gap_lg = "g1rspah0";
export const gap_md = "g513fow";
export const gap_sm = "g2x70v9";
export const gap_xs = "gtuj3zo";
export const gap_xxs = "geu30p8";
export const detailWrapper = "db0io6i";
export const detail = "deg9gpk";
export const asideWrapper = "a11fpzc2";
export const aside = "a9pq1o";
export const fixed = "f1188173";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");